import { useEffect, useRef, useState } from "react";

export const useHover = () => {
    const [value, setValue] = useState(false);
    const ref = useRef<HTMLElement | null>(null);
    const handleMouseOver = () => setValue(true);
    const handleMouseOut = () => setValue(false);

    // eslint-disable-next-line consistent-return
    useEffect(() => {
        const node = ref.current;
        if (node) {
            node.addEventListener("mouseover", handleMouseOver);
            node.addEventListener("mouseout", handleMouseOut);
            return (): void => {
                node.removeEventListener("mouseover", handleMouseOver);
                node.removeEventListener("mouseout", handleMouseOut);
            };
        }
    }, []);

    return [ref, value];
};
